export default {
    deleteLabel: 'Want to delete irrelevant skills and update your score again?'
}